// @flow

import { observer } from "mobx-react";
import React from "react";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

import AuthButton from "app/components/AuthButton/AuthButton";
import PasswordForm from "app/components/PasswordForm/PasswordForm";

import whiteThemeImage from "./whiteThemeImage.png";
import darkThemeImage from "./darkThemeImage.jpg";
import "./SignupView.scss";

type Props = {};

type State = {
    signupWithEmail: boolean
};

@observer
export default class SignupView extends React.Component<Props, State> {
    state = {
        signupWithEmail: false
    };

    handleRequestSingupWithEmail = (event: Event) => {
        event.preventDefault();
        this.setState({ signupWithEmail: true });
    };

    handleCancelSignupWithEmail = () => {
        this.setState({ signupWithEmail: false });
    };

    render() {
        return (
            <div className="SignupView">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <img
                                src={
                                    GlobalSettingsStore.defaultTheme === "white"
                                        ? whiteThemeImage
                                        : darkThemeImage
                                }
                                alt=""
                                className="SignupView__image"
                            />
                        </div>

                        <div className="SignupView__content col-md-6">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderForm() {
        return (
            <div>
                {this.renderInitialForm()}
                {this.renderSignupEmail()}

                <div className="SignupView__login">
                    Have an account already?{" "}
                    <a href="/login" className="SignupView__login-button">
                        Login
                    </a>{" "}
                    here.
                    <br />
                    <p className="accept-terms">By joining Timelinely, you agree to our <a href='/terms-and-conditions' className="primary-link">Terms of Service</a> and <a href='/privacy-policy' className="primary-link">Privacy Policy</a>.</p>
                </div>
            </div>
        );
    }

    renderInitialForm() {
        if (this.state.signupWithEmail) return null;

        return (
            <div className="SignupView__form SignupView__form--initial animated fadeIn">
                <header className="SignupView__form-header">
                    <h1 className="SignupView__form-title">
                        Timelinely is perfect for:
                    </h1>
                </header>

                {this.renderTopics()}

                <div className="SignupView__buttons">
                    <AuthButton name="google" />
                    <AuthButton
                        name="facebook"
                        text="Continue with Facebook"
                        image
                    />
                    <AuthButton name="twitter" />

                    <div className="SignupView__buttons-separator">OR</div>

                    <AuthButton
                        name="email"
                        icon="envelope-o"
                        onClick={this.handleRequestSingupWithEmail}
                    />
                </div>
            </div>
        );
    }

    renderSignupEmail() {
        if (!this.state.signupWithEmail) return null;

        return (
            <form
                className="SignupView__form SignupView__form--signup animated fadeIn"
                method="post"
            >
                <header className="SignupView__form-header">
                    {this.renderBackButton()}
                    <h1 className="SignupView__form-title">
                        Sign up to create your video stories!
                    </h1>
                </header>

                <div className="form-group">
                    <div className="form-group">
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Your Email"
                            autoFocus
                            required
                            pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            name="first_name"
                            className="form-control"
                            placeholder="First name"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            name="last_name"
                            className="form-control"
                            placeholder="Last name"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <PasswordForm />
                    </div>

                    <button className="SignupView__form-submit">Sign Up</button>
                </div>
            </form>
        );
    }

    renderBackButton() {
        return (
            <button
                type="button"
                className="SignupView__form-back"
                onClick={this.handleCancelSignupWithEmail}
            >
                <i className="fa fa-chevron-left" /> Back
            </button>
        );
    }

    renderTopics() {
        return (
            <div className="SignupView__topics">
                {this.renderTopic("Sharing your favorite videos with friends")}
                {this.renderTopic("Showcasing or reviewing products")}
                {this.renderTopic("Training or educational videos")}

                <footer className="SignupView__topics-footer">
                    and many more use cases...
                </footer>
            </div>
        );
    }

    renderTopic(text: string) {
        return (
            <div className="SignupView__topic">
                <i className="fa fa-check" /> {text}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/auth/Signup/SignupView.js